import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./home.scss";
import Widget from "../../components/widget/Widget";
import DashboardService from "../../services/dashboard";
import SponsoredService from "../../services/sponsored";
import { useState, useEffect } from "react";
import sponsoredColumnsHeader from "../sponsored/ColumnsHeaderData";
import Datatable from "../../components/datatable/Datatable";
import { parsePaymentDate } from "../../utils/date";
import {
  SponsorTrendChart,
  CategoryDistributionChart,
} from "../../components/chart/Chart";
import Loader from "../../components/spinner/Spinner";

const Home = () => {
  const [dashboard, setDashboard] = useState([]);
  const [sponsors, setSponsors] = useState([]);
  const [latestSponsors, setLatestSponsors] = useState([]);
  const [isSidebar, setIsSidebar] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      await Promise.all([getAllDashboard(), getLatestSponsors()]);
      setLoading(false);
    };
    load();
  }, []);

  const getAllDashboard = async () => {
    try {
      let { data } = await DashboardService.fetchDashboardCounts();
      setDashboard(data.data);
    } catch (err) {
      console.log(err);
    }
  };
  const getLatestSponsors = async () => {
    try {
      const { data } = await SponsoredService.fetchSponsor();
      const sponsorList = Array.isArray(data?.data) ? data.data : [];
      const sorted = [...sponsorList].sort(
        (a, b) =>
          parsePaymentDate(b.mentored_on_date) -
          parsePaymentDate(a.mentored_on_date),
      );
      setLatestSponsors(sorted.slice(0, 5));
      setSponsors(sorted);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="home">
      <Sidebar isSidebar={isSidebar} />
      <div className="homeContainer">
        <Navbar isSidebar={isSidebar} setIsSidebar={setIsSidebar} />
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="widgets">
              {dashboard?.length > 0 &&
                dashboard.map((d) => <Widget key={d.table_name} data={d} />)}
            </div>
            {/* <div className="listContainer">
          <Datatable
            pageTitle={"Latest Transactions"}
            columnsData={paymentColumnsHeader.columnsData}
            rowData={payments}
            actionColumn={[]}
          />
        </div> */}
            <div className="charts">
              <div className="chartCard">
                <SponsorTrendChart
                  data={sponsors}
                  title="Total Sponsorship Trend"
                />
              </div>
              <div className="chartCard">
                <CategoryDistributionChart
                  data={sponsors}
                  title="Sponsored Kids by Category (%)"
                />
              </div>
            </div>
            <div className="latestSponsoredPanel">
              <Datatable
                pageTitle={"Latest Sponsored Kids"}
                columnsData={sponsoredColumnsHeader.columnsData}
                rowData={latestSponsors}
                actionColumn={[]}
                showPagination={false}
                defaultSortModel={[{ field: "mentored_on_date", sort: "desc" }]}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Home;
